import type { DocParts, DocumentElement, FootersElement, HeadersElement } from '../internal';
import { createDefaultDocElement, createDefaultFooters, createDefaultHeaders } from '../internal';

export function createDefaultDocumentParts(options?: {
  documentElement?: DocumentElement;
  footersElement?: FootersElement;
  headersElement?: HeadersElement;
}): DocParts {
  const {
    documentElement = createDefaultDocElement(),
    footersElement = createDefaultFooters(),
    headersElement = createDefaultHeaders(),
  } = options ?? {};
  return [documentElement, headersElement, footersElement];
}
